import type { TIrrigationSchedulerStoreState } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import moment from 'moment-timezone'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'

export const getSelectedPropertyTimezoneForIrrigationScheduler = (
  fass: TFieldAssetStoreState,
  isss: TIrrigationSchedulerStoreState,
) => {
  if (isss.selectedPropertyId) {
    const property = fass.properties?.[Number(isss.selectedPropertyId)]

    if (property) {
      return property.timezone
    }
  }

  return moment.tz.guess()
}
